module.exports = __webpack_public_path__ + "img/MEDIA057.0d92ffa8.jpg";